export interface Normalizer {
  normalize(pathname: string): string
}
